import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetVolumeSetQuery } from "../../store/api/volumeSetApi";
import { VolumeSetDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { VOLUMESET_UPDATE_INTERVAL_MS } from "../../envVariables";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";
import { useGvcContextNavigation } from "../../reactHooks/useGvcContextNavigation";

type RouteParams = "org" | "gvc" | "volumeset";
export const VolumeSetDetailInitializer: React.FC = () => {
  const { org: orgName, gvc: gvcName, volumeset: volumesetName } = useParams<RouteParams>();
  useGvcContextNavigation("volumeset");

  const selfLink = `/org/${orgName}/gvc/${gvcName}/volumeset/${volumesetName}`;

  const { data: volumeSet, isLoading, isFetching, isError, error, refetch } = useGetVolumeSetQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
    pollingInterval: VOLUMESET_UPDATE_INTERVAL_MS,
  });

  if (!volumeSet && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="volumeset" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !volumeSet) {
    return <IncorrectItem kind="volumeset" canCreate={true} />;
  }

  return <VolumeSetDetailForm volumeSet={volumeSet} />;
};
